import { RequestService } from '../../services/RequestService';
import { GET_FOREIGN_LANGUAGES } from '../constants';

export const getForeignLanguages = payload => {
  return RequestService.get(GET_FOREIGN_LANGUAGES);
};
